module.exports = __webpack_public_path__ + "img/marmelaedchen-geschenk-rose_xs.aa240277.jpg";